module.exports = __webpack_public_path__ + "img/video-bottom.9ca1a8aa.png";